import { render, staticRenderFns } from "./SectionHero.vue?vue&type=template&id=3d816e00&scoped=true"
import script from "./SectionHero.vue?vue&type=script&lang=ts"
export * from "./SectionHero.vue?vue&type=script&lang=ts"
import style0 from "./SectionHero.vue?vue&type=style&index=0&id=3d816e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d816e00",
  null
  
)

export default component.exports